import moment from 'moment';
window.moment = moment;
import 'fullcalendar';
import 'fullcalendar/dist/fullcalendar.css';
import angular from 'angular';
import ngRoute from 'angular-route';
import 'angular-ui-calendar';
import booksMenu from '../../menu/Menu';
import booksDom from '../../booksDom';
import events from './services/Events';
import './eventsAdmin.css';
/** Dom */
import {
  ReportsDialogService,
  reportsDialogComponent
} from './dom/ReportsDialog/ReportsDialog';
import {
  eventsComponent,
  ET_LINK,
  openEventFilter,
  EventsCtrlController
} from './dom/events/events';
import {
  addGuestDialogComponent,
  AddGuestDialogService
} from './dom/AddChangeEventDialog/AddGuestDialog/AddGuestDialog';
import { attendeesComponent } from './dom/AddChangeEventDialog/attendees/attendees';
import {
  SelectEventTypeDialogService,
  selectEventTypeComponent
} from './dom/AddChangeEventDialog/SelectEventTypeDialog/SelectEventTypeDialog';
import {
  ticketsComponent,
  TicketsController
} from './dom/AddChangeEventDialog/tickets/tickets';
import {
  UploadAttendeesDialogService,
  uploadAttendeesDialogComponent
} from './dom/AddChangeEventDialog/UploadAttendeesDialog/UploadAttendeesDialog';
import {
  AddChangeEventDialogService,
  addChangeEventDialogComponent,
  runTemplateCache
} from './dom/AddChangeEventDialog/AddChangeEventDialog';

export default angular
  .module('csm.books.eventsAdmin', [
    booksMenu,
    ngRoute,
    events,
    booksDom,
    'ui.calendar'
  ])
  .controller('appController', appController)
  .config(Config)
  .constant('Tabs', Tabs)
  .component('events', eventsComponent)
  .constant('ET_LINK', ET_LINK())
  .filter('openEventFilter', openEventFilter)
  .controller('EventsCtrl', EventsCtrlController)
  .service('AddChangeEventDialog', AddChangeEventDialogService)
  .component('addChangeEventDialog', addChangeEventDialogComponent)
  .run(runTemplateCache)
  .service('UploadAttendeesDialog', UploadAttendeesDialogService)
  .component('uploadAttendeesDialog', uploadAttendeesDialogComponent)
  .component('addGuestDialog', addGuestDialogComponent)
  .service('AddGuestDialog', AddGuestDialogService)
  .service('SelectEventTypeDialog', SelectEventTypeDialogService)
  .component('selectEventType', selectEventTypeComponent)
  .component('attendees', attendeesComponent)
  .component('tickets', ticketsComponent)
  .controller('TicketsCtrl', TicketsController)
  .service('ReportsDialog', ReportsDialogService)
  .component('reportsDialog', reportsDialogComponent).name;

/*****************************************************************************
 * Constant:
 *
 * List of navigation buttons with their properties.
 *****************************************************************************/
/* @ngInject */ function Tabs() {
  return [
    { display: 'Events', active: true, route: '/' },
    { display: 'Past Events', active: false, route: '/past/' }
  ];
}

/*****************************************************************************
 * Config:
 *
 * Configure app routes.
 *****************************************************************************/
/* @ngInject */ function Config($routeProvider) {
  var resolve = {
    list: function ($q, Events) {
      return Events.getList().then(function (resp) {
        var current = [];
        var past = [];

        /*------------------------------------------------------*/
        /* Filter events into 2 lists, current and past events. */
        /*------------------------------------------------------*/
        for (var i = 0; i < resp.length; i++) {
          if (resp[i].inactive) past.push(resp[i]);
          else current.push(resp[i]);
        }

        return !resp ? $q.reject() : { current: current, past: past };
      });
    }
  };

  $routeProvider
    .when('/', {
      resolve: resolve,
      template:
        '<events list="$resolve.list.current" show-buttons="true"></events>'
    })
    .when('/past/', {
      resolve: resolve,
      template:
        '<events list="$resolve.list.past"    show-buttons="false" old-events="true"></events>'
    })
    .otherwise({ redirectTo: '/' });
}

/*******************************************************************************
 * Controller: appController
 *
 * Main controller for the Events Admin app.
 *******************************************************************************/
/* @ngInject */ function appController($location, $scope, BusyScreen, Tabs) {
  /*---------------------*/
  /* Add default routes. */
  /*---------------------*/
  $scope.options = Tabs();

  /***************************************************************************
   * onOption */
  /**
   * Nav buttons click handler. Clears the former active option and navigates to
   * the route for the passed option.
   *
   * @param   option  Option to make active
   ***************************************************************************/
  $scope.onOption = function (option) {
    /*----------------------------------------*/
    /* Ignore if the option is already active */
    /*----------------------------------------*/
    if (option.active) return;

    /*------------------------------------------*/
    /* Set active flag on user selection and    */
    /* disable on the other navigation buttons. */
    /*------------------------------------------*/
    if ($scope.options)
      $scope.options.forEach(function (c) {
        c.active = false;
      });

    option.active = true;

    /*--------------------*/
    /* Navigate to route. */
    /*--------------------*/
    $location.path(option.route);
  };

  function init() {
    /*----------------------------------------*/
    /* Highlight the appropriate option based */
    /* on the current route on page load.     */
    /*----------------------------------------*/
    $scope.onOption(
      $scope.options
        .filter(function (option) {
          return option.route == $location.path();
        })
        .shift()
    );
    BusyScreen.setBusy(false);
  }

  init();
}
